// extracted by mini-css-extract-plugin
export var button = "training-module--button--dQ-P2";
export var circle = "training-module--circle--uxzt6 training-module--figure--RcQbg";
export var container = "training-module--container--nhtHL";
export var course = "training-module--course--QVZ59";
export var courses = "training-module--courses--PTky8";
export var figure = "training-module--figure--RcQbg";
export var footer = "training-module--footer--pkp5g";
export var main = "training-module--main--C+FOp";
export var pentagon = "training-module--pentagon--vx4bS training-module--figure--RcQbg";
export var triangle = "training-module--triangle--Wjfxd training-module--figure--RcQbg";
export var type0 = "training-module--type0--W57AC";
export var type1 = "training-module--type1--kS2o3";
export var type2 = "training-module--type2--mkvH9";
export var uppercase = "training-module--uppercase--dsKjw";
export var video = "training-module--video--wON+y";